import { Box, Button, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { titleTextColor } from 'assets/styles/_palette';

export const ModalContent = styled(Box)({
	...flexMixin({ direction: 'column', gap: 32 }),
	margin: '48px 0',
});

export const ModalTitle = styled(Typography)({
	fontSize: '24px',
	fontWeight: 700,
	lineHeight: '133.4%',
	color: titleTextColor,
});

export const ModalSubtitle = styled(Typography)({
	fontSize: '16px',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: titleTextColor,
});

export const ModalMainContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 24 }),
	width: '100%',
});

export const ModalUsers = styled(Box)({
	...flexMixin({ justify: 'flex-start', align: 'flex-start', direction: 'column', gap: 16 }),
	width: '100%',
	maxHeight: '440px',
	overflowY: 'auto',
});

export const ModalUser = styled(Box)({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
});

export const ConfirmButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});

export const CancelButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});

export const ModalButtons = styled(Box)({
	...flexMixin({ gap: 16 }),
	width: '100%',
});
